import store from '@/store';

export const UsingDefaultPasswordGuard = (to, from, next) => {
  const user = store.getters.currentUser;
  if (user.using_default_password) {
    return next({name: 'update-user-password'});
  }

  return next();
};